// src/services/footballApi.js

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost/DiceAce12/backend';

// Format odds
export const formatOddsValue = (odds, format = 'decimal') => {
    if (!odds || odds === null) return '-';
    
    const numOdds = parseFloat(odds);
    if (isNaN(numOdds)) return '-';
    
    if (format === 'decimal') {
        return numOdds.toFixed(2);
    } else if (format === 'fractional') {
        const fractional = (numOdds - 1).toFixed(2);
        return `${fractional}/1`;
    } else if (format === 'american') {
        if (numOdds >= 2.0) {
            return `+${Math.round((numOdds - 1) * 100)}`;
        } else {
            return `-${Math.round(100 / (numOdds - 1))}`;
        }
    }
    return numOdds.toFixed(2);
};

// Convert decimal to American for display
export const decimalToAmerican = (decimal) => {
    if (!decimal || decimal === null) return null;
    if (decimal >= 2.0) {
        return `+${Math.round((decimal - 1) * 100)}`;
    } else {
        return `-${Math.round(100 / (decimal - 1))}`;
    }
};

// API functions
export const FootballAPI = {
    // Get fixtures grouped by league for a specific date
    getFixtures: async (date) => {
        try {
            // console.log('Fetching fixtures for date:', date);
            
            const response = await fetch(`${API_BASE}/api/football/fixtures/${date}`, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            
            const data = await response.json();
            // console.log('Fixtures received:', data.data?.length || 0);
            return data;
        } catch (error) {
            // console.error('Failed to fetch fixtures:', error);
            return { data: [], error: error.message };
        }
    },
    
    // Get live fixtures
    getLiveFixtures: async () => {
        try {
            const response = await fetch(`${API_BASE}/api/football/live`, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            
            const data = await response.json();
            return data;
        } catch (error) {
            // console.error('Failed to fetch live fixtures:', error);
            return { data: [] };
        }
    },
    
    // Get odds for a specific fixture
    getOdds: async (fixtureId) => {
        try {
            const response = await fetch(`${API_BASE}/api/football/odds/${fixtureId}`, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            
            const data = await response.json();
            return data;
        } catch (error) {
            // console.error('Failed to fetch odds:', error);
            return { data: [] };
        }
    },
    
    // NEW: Get complete match details
    getMatchDetails: async (fixtureId) => {
        try {
            const response = await fetch(`${API_BASE}/api/football/match/${fixtureId}`, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            
            const data = await response.json();
            return data;
        } catch (error) {
            // console.error('Failed to fetch match details:', error);
            return { success: false, error: error.message };
        }
    },
    
    // NEW: Get available dates
    getAvailableDates: async () => {
        try {
            const response = await fetch(`${API_BASE}/api/football/dates`, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            
            const data = await response.json();
            return data;
        } catch (error) {
            // console.error('Failed to fetch available dates:', error);
            return { data: [] };
        }
    },
    
    // NEW: Get leagues for a date
    getLeagues: async (date) => {
        try {
            const response = await fetch(`${API_BASE}/api/football/leagues?date=${date}`, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            
            const data = await response.json();
            return data;
        } catch (error) {
            // console.error('Failed to fetch leagues:', error);
            return { data: [] };
        }
    }
};

export default FootballAPI;